import React from 'react';
import { AiOutlineFileImage } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge/es5';
import Divider from './Divider';

function FileInput({
  files,
  maxFiles = 2,
  multiple,
  onChange,
  onRemove,
  ...props
}) {
  return (
    <div className="flex flex-col gap-2  ">
      {/* input row */}

      <div className="rounded-lg border border-primary/20 flex gap-2 p-3 relative">
        <div className="flex items-center justify-self-end">
          <label
            className={twMerge(
              'text-sm text-primary cursor-pointer flex gap-1 items-center',
              files?.length >= maxFiles && 'text-black/30'
            )}
          >
            <div className="flex gap-2 items-center overflow-hidden">
              <AiOutlineFileImage className="text-2xl text-primary" />
              <span className="text-sm text-white/60">
                {getSelectText(files?.length, maxFiles)}
              </span>
            </div>
            Browse
          </label>

          <input
            type="file"
            // for android sdk to check max files count
            id="file-input"
            data-max-files={maxFiles}
            disabled={files?.length >= maxFiles}
            className="opacity-0 absolute top-0 right-0 bottom-0 left-0 w-full h-full cursor-pointer"
            onChange={onChange}
            multiple={multiple}
            {...props}
          />
        </div>
      </div>
      {/*  files row */}
      {files?.length > 0 && (
        <>
          <div className="flex flex-col w-full gap-2 px-4">
            {files?.map((file, index) => (
              <div className="grid grid-cols-[1fr_60px]" key={index}>
                <span
                  className="text-sm text-white/60 overflow-hidden flex gap-2
              "
                >
                  <span className="line-clamp-1 text-ellipsis">
                    {file.name}
                  </span>
                </span>
                <span
                  className="justify-self-end text-sm text-red-400 cursor-pointer"
                  onClick={() => {
                    onRemove(index);
                  }}
                >
                  Remove
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default FileInput;

function getSelectText(length, maxLength) {
  if (length === 0 && maxLength > 1) {
    return `You can select upto ${maxLength} files.`;
  } else if (length === 0) {
    return 'Select a file';
  } else if (length === 1) {
    return '1 file selected';
  } else {
    return `${length} files selected`;
  }
}
